import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { LoginService } from 'src/app/service/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public loginValid = true;
  public username = '';
  public password = '';
  public hidePassword = true;

  formulario: FormGroup;
  usuario = { username: '', password: '' };
  token: any;

  constructor(
    private loginService: LoginService,
    private router: Router,
    public dataService: DataService
  ) { }

  public onSubmit() {
    this.usuario.username = this.username;
    this.usuario.password = this.password;
    this.loginService.login(this.usuario);
  }

  public recuperar() {
    this.loginService.recuperar(this.usuario.username);
  }

  ngOnInit() {
    this.token = localStorage.getItem('token');
    if (this.token !== null &&
      this.token.toString().trim() !== null) {
      this.router.navigate(['home']);
    }
    this.load();
  }

  load() {

    const HAS_RELOAD = 'hasReload';
    const hasReload = sessionStorage.getItem(HAS_RELOAD);
    if (!hasReload && !this.dataService.logado) {
      sessionStorage.setItem(HAS_RELOAD, 'true');
      location.reload();
    }
  }
}
